<template>
  <div>
    <div class="d-flex flex-wrap align-center px-1">
      <v-card
        v-for="(file, index) in renderFiles"
        :key="`clipboard-file-${index}`"
        class="clipboard-img"
        elevation="0"
        :disabled="uploading"
        :loading="uploading"
      >
        <div
          v-if="!uploading"
          class="delete-clipboard-img-btn"
        >
          <v-btn
            type="button"
            fab
            x-small
            width="20"
            height="20"
            color="white"
            class="button-delete border-0 rounded-circle"
            @click="removeImage(index)"
          >
            <Icon
              :size="15"
              :color="'rgba(0,0,0,.54)'"
              :icon="'close'"
            />
          </v-btn>
        </div>
        <div>
          <v-img
            data-bs-toggle="tooltip-disabled"
            data-bs-placement="top"
            :src="getSrc(file.src ? file.src : file.type)"
            class="bg-dark rounded"
            style="object-fit: contain"
            width="63"
            height="63"
          ></v-img>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'

require('@/plugins/FileUpload')

@Component({
  components: {
    Icon: () => import(/* webpackPrefetch: true */ '@/components/Icon.vue')
  },
  props: {
    awsS3Url: {
      type: String,
      default: process.env.VUE_APP_AWS_S3_URL
    }
  },
  watch : {
    files () {
      this.$emit('addFiles', this.files)
    }
  }
})
export default class Clipboard extends Vue {
  data () {
    return {
      uploading: false,
      files: [],
      renderFiles: [],
      alert: {
        color: '',
        message: ''
      }
    }
  }

  handlerErrorValidation (errors) {
    this.alert.color = 'error'

    for (const key in errors) {
      errors[key].forEach(item => {
        this.alert.message += ` ${item},`
      })
    }

    this.$store.commit('notify', this.alert)
    console.log('errors validation', errors)
  }

  bytesToKb (bytes) {
    if (!bytes) {
      return '0 KB'
    }

    return Number((bytes / 1024).toFixed(0))
  }

  getSrc (extension) {
    let src = ''

    if (extension.indexOf('data:image/') !== -1) {
      src = `${extension}`
    } else if (extension.indexOf('pdf') !== -1) {
      src = `${this.awsS3Url}/images/chat/ocular-chat-pdf-icon.png`
    } else if (extension.indexOf('wordprocessingml') !== -1) {
      src = `${this.awsS3Url}/images/chat/ocular-chat-doc-icon.png`
    }

    return src
  }

  getBackgroundImage(file) {
    if (this.files.length) {
      return this.files.find((element) => element.name === file.name && element.size === file.size) ?? false
    }
  }

  sendFile () {
    this.uploading = true

    this.$fileUpload.uploadSessionFile(this.files, this.$store.state.storage.room.session.id)
      .then((response) => {
        const res = response

        if (res.statusCode === 0) {
          const attachments = res.uploads
          this.files = []
          this.renderFiles = []

          this.$emit('setAttachments', attachments)
        } else if (res.statusCode === 2) {
          this.uploading = false
          this.handlerErrorValidation(res.detail)
        } else {
          this.uploading = false
          console.log('error de servidor')
        }
      })
      .catch((error) => {
        console.log(error)
        this.uploading = false
      })
      .then(() => {
        this.uploading = false
      })
  }

  pasteFile (event) {
    let items = (event.clipboardData || event.originalEvent.clipboardData).items

    if (this.files.length >= 4) {
      this.alert.color = 'error'
      this.alert.message = this.$t('files.limitExceeded')
      this.$store.commit('notify', this.alert)
      return false
    }

    for (let i = 0; i < items.length; i++) {
      let file = items[i].getAsFile()

      if (!file) {
        return false
      }

      let sizeFile = this.bytesToKb(file.size)

      if (sizeFile > 7024) {
        this.alert.color = 'error'
        this.alert.message = this.$t('files.maximumSize')
        this.$store.commit('notify', this.alert)
        return false
      }

      if (file && this.getBackgroundImage(file)) {
        this.alert.color = 'error'
        this.alert.message = this.$t('files.fileExists')
        this.$store.commit('notify', this.alert)
        continue
      }

      if (items[i].type.indexOf('image') !== -1) {
        let reader = new FileReader()

        reader.onload = (event) => {
          let image = new Image()
          image.src = event.target.result
          this.renderFiles.push(image)
        }

        this.files.push(file)
        reader.readAsDataURL(file)
      } else if (
        items[i].type.indexOf('pdf') !== -1 ||
        items[i].type.indexOf('wordprocessingml') !== -1
      ) {
        this.renderFiles.push(file)
        this.files.push(file)
      } else {
        this.alert.color = 'error'
        this.alert.message = this.$t('files.fileNotAllowed')
        this.$store.commit('notify', this.alert)
      }
    }
  }

  removeImage (index) {
    if (this.files[index] !== -1 && this.renderFiles[index] !== -1) {
      this.files.splice(index, 1)
      this.renderFiles.splice(index, 1)
    }
  }
}
</script>

<style scoped>
.clipboard-img {
  position: relative;
  border-radius: 5px;
  border: 1px solid #bbbbbb;
  margin-right: 10px;
  margin-top: 9px;
}

.clipboard-img.loading {
  opacity: .7 !important;
}

.clipboard-img:last-child {
  margin-right: 0px !important;
}

.clipboard-img .delete-clipboard-img-btn {
  position: absolute;
  z-index: 9;
  top: -8px;
  right: -8px;
}
</style>
